module.exports = __webpack_public_path__ + "media/images/games/cs-go/square-6f6ae7dcc4d25e95af9d46d5ee3cff7d.jpg";